import React from 'react'
import { PerthNowSomethingWentWrong } from 'component-library/errors/SomethingWentWrong/PerthNowSomethingWentWrong/PerthNowSomethingWentWrong'
import { RouteStatus } from 'common/routing/RouteStatus'
import { createRegisterableComponent } from 'common/routing/page-definition'

export const PerthNowSomethingWentWrongRegistration = createRegisterableComponent(
    'something-went-wrong',
    () => (
        <RouteStatus statusCode={500}>
            <PerthNowSomethingWentWrong />
        </RouteStatus>
    )
)
